export default __webpack_public_path__ + "static/media/background1.c3d5edca.png";